<template>
  <div>
    <h2 v-if="withHeader" class="mb-4 text-heading-3-desktop text-black-78">Zgodovina cen nepremičnin</h2>
    <figure>
        <div
          class="h-min-[200px] w-full rounded-3xl lg:h-min-[320px] lg:bg-white lg:shadow lg:p-11 flex flex-col xl:flex-row items-center gap-8">
          <div class="w-full xl:w-1/3 flex justify-between flex-col sm:flex-row xl:flex-col gap-8">
            <arvio-chart ref="priceChartRegion" :api_key="arvioToken" :api_host="arvioApiHost"
            graph_type="transaction_volume_metric" :region_name="regionName"></arvio-chart>

            <arvio-chart ref="priceChartSlovenia" :api_key="arvioToken" :api_host="arvioApiHost"
            graph_type="transaction_price_avgm2_metric" :region_name="regionName"></arvio-chart>
          </div>

          <div class="w-full xl:w-2/3">
            <arvio-chart ref="priceChart" :api_key="arvioToken"
              :api_host="arvioApiHost" graph_type="price_index_timeseries"
              :region_name="regionName"></arvio-chart>
          </div>
        </div>
    </figure>
  </div>
</template>

<script>
  // Set custom css and inject it into the shadow dom
  let styles = `
    .arvio-chart-wrapper {
      margin-bottom: 0;
      max-width: 100% !important;
    }

    .dashboard-graph--n24.dashboard-graph {
      padding: 0 !important;
      border: 0;
      border-radius: 0;
      font-family: inherit;
    }

    .dashboard-graph--n24 h3.text-right {
      text-align: left;
    }
  `;

  let style = document.createElement('style');
  style.innerHTML = styles;

  let style2 = document.createElement('style');
  style2.innerHTML = styles;

  let style3 = document.createElement('style');
  style3.innerHTML = styles;

  export default {
    name: "ListingPriceHistory",

    props: {
      regionName: {
        type: String,
        required: true
      },
      withHeader: {
        type: Boolean,
        required: false,
        default: true,
      }
    },

    data() {
      return {
        arvioToken: process.env.MIX_ARVIO_TOKEN,
        arvioApiHost: process.env.MIX_ARVIO_API_HOST,
      };
    },

    created() {
      // Dynamically load the arvio-chart library script otherwise we get errors
      const script = document.createElement('script');
      script.src = 'https://d2a9figy6s87x6.cloudfront.net/arvio-chart/prod/arvio-chart.min.js';
      script.async = true;
      script.onload = this.initializeArvioChart;
      document.head.appendChild(script);
    },

    methods: {
      triggerResizeEvent() {
        const resizeEvent = new Event('resize');
        window.dispatchEvent(resizeEvent);
      },

      waitForElementToLoad() {
        return new Promise((resolve, reject) => {
          const interval = setInterval(() => {
            let arvioChartWrapper = this.$refs.priceChart.shadowRoot;
            let arvioRegionChartWrapper = this.$refs.priceChartRegion.shadowRoot;
            let arvioSloveniaChartWrapper = this.$refs.priceChartSlovenia.shadowRoot;

            if (arvioChartWrapper && arvioRegionChartWrapper && arvioSloveniaChartWrapper) {
              let arvioGraph = arvioChartWrapper.querySelector('.dashboard-graph');
              let arvioRegionGraph = arvioRegionChartWrapper.querySelector('.dashboard-graph');
              let arvioSloveniaGraph = arvioSloveniaChartWrapper.querySelector('.dashboard-graph');

              if(arvioGraph && arvioRegionGraph && arvioSloveniaGraph) {
                clearInterval(interval);
                resolve();
              }
            }
          }, 100);
        });
      },
    },

    mounted() {
      this.waitForElementToLoad().then(() => {
        let arvioGraph = this.$refs.priceChart.shadowRoot.querySelector('.dashboard-graph');
        let arvioRegionGraph = this.$refs.priceChartRegion.shadowRoot.querySelector('.dashboard-graph');
        let arvioSloveniaGraph = this.$refs.priceChartSlovenia.shadowRoot.querySelector('.dashboard-graph');

        arvioGraph.classList.add('dashboard-graph--n24');
        arvioRegionGraph.classList.add('dashboard-graph--n24');
        arvioSloveniaGraph.classList.add('dashboard-graph--n24');

        this.$refs.priceChart.shadowRoot.appendChild(style);
        this.$refs.priceChartRegion.shadowRoot.appendChild(style2);
        this.$refs.priceChartSlovenia.shadowRoot.appendChild(style3);

        this.triggerResizeEvent(); // Make sure the chart is rendered correctly
      });
    }
  };
</script>